/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import i18nIsoCountries from 'i18n-iso-countries';

/**
 * navigator language에서 얻을 수 있는 값을 표준화하기 위해서 필요
 * navigator language로 가능한 값 : "en", "en-US", "fr", "fr-FR", "es-ES", etc.
 * @see https://developer.mozilla.org/ko/docs/Web/API/NavigatorLanguage/language
 */
export const navigatorLanguage = navigator.language ? navigator.language.substring(0, 2) : 'ko';

/**
 * browser 환경에서는 countries.registerLocale(require("i18n-iso-countries/langs/en.json")) 작업 필요
 * @see https://github.com/michaelwittig/node-i18n-iso-countries#installing
 */
const registerLocale = (language: string) => {
  i18nIsoCountries.registerLocale(require(`i18n-iso-countries/langs/${language}.json`));
  return i18nIsoCountries.getNames(language);
};

export const locales = registerLocale(navigatorLanguage);
export const countries = Object.entries(locales)
  .map((value) => (Array.isArray(value[1]) ? value[1][0] : value[1]))
  .sort((a, b) => a.toString().localeCompare(b.toString()));

export default registerLocale;
